<!--充电机数据 -->
<template>
  <div>
    <!-- 列表 -->
    <div id="btUpdateInfo" style="position: relative;">
      <el-table id="btUpdateInfoTable" v-loading="loading" :data="tableData" style="width: 100%" border>
        <el-table-column prop="eventTime" :label="$t('warningPage.CreatedAt')" align="center" />
        <el-table-column prop="eventId" :label="$t('chargeEvent.event')" align="center">
          <template slot-scope="scope">
            {{ $t('chargeEvent.event_' + scope.row.eventId) }}
          </template>
        </el-table-column>
        <el-table-column prop="batteryVoltage" :label="$t('warningPage.Voltage')" align="center" />
        <el-table-column prop="chargingTime" :label="$t('yhubReport.chargeDuration')" align="center" />
        <el-table-column prop="batteryCapacity" :label="$t('BondOrUpdateDevice.Capacity')" align="center" />
        <el-table-column prop="chargingCurve" :label="$t('QR.Profile')" align="center" />
        <el-table-column prop="mainsVoltage" :label="$t('QR.ACVoltage')" align="center" />
        <el-table-column prop="batteryTemperature" :label="$t('QR.BTS')" align="center" />
        <el-table-column prop="createBy" :label="$t('QR.Uploader')" align="center" />
      </el-table>
      <!-- 列表模块————分页 -->
      <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination
            v-if="pageshow"
            background
            current-page.sync="listQuery.pageInfo.page"
            :page-sizes="listQuery.pageInfo.pageList"
            :page-size="listQuery.pageInfo.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listQuery.pageInfo.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { chargerPage, pageBluetoothDetail } from '@/api/blueTooth'
import { pagination } from '@/utils/init_table'
// import i18n from '@/i18n'
import { getDateAndHour, usedTime } from '@/utils/updateTime.js'
import { temChangeUnit } from '@/utils/temChange.js'

export default {
  props: {
    activeTab: {
      type: String,
      default: ''
    },
    selectDay: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end,
      loading: true,
      tableData: []
    }
  },
  watch: {
    activeTab(newValue, oldValue) {
      if (newValue == 'chargeHistoryPane') this.queryList()
    },
    selectDay(newValue, oldValue) {
      if (this.activeTab == 'chargeHistoryPane') this.queryList()
    }
  },
  created() {
    this.queryList()
  },
  methods: {
    queryList() {
      var param = {
        'endDate': '',
        'mcuId': this.$route.query.chargerSn,
        'showAll': false,
        'startDate': '',
        'type': 3,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      this.loading = true
      // console.log(this.selectDay)
      if (this.selectDay && this.selectDay.length > 0) {
        param.startDate = new Date(this.selectDay[0]).setHours(0, 0, 0, 0)
        param.endDate = new Date(this.selectDay[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1
      }
      pageBluetoothDetail(param).then(res => { // 基本信息
        this.loading = false
        if (res.resultCode === 1001 && res.resultModel) {
          this.tableData = []
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          if (!res.resultModel.list) return
          var list = res.resultModel.list || []
          console.log(JSON.parse(res.resultModel.list[0].jsonData))
          list.forEach(v => {
            var jsonDataObj = JSON.parse(v.jsonData)
            if (jsonDataObj.timestamp) jsonDataObj.eventTime = getDateAndHour(jsonDataObj.timestamp, 'noSecond')
            // jsonDataObj.chargeTime = jsonDataObj.date + jsonDataObj.time
            jsonDataObj.batteryVoltage = jsonDataObj.batteryVoltage + ' V'
            jsonDataObj.batteryCapacity = jsonDataObj.batteryCapacity + ' Ah'
            jsonDataObj.mainsVoltage = jsonDataObj.mainsVoltage + ' V'
            jsonDataObj.createBy = v.createBy
            jsonDataObj.batteryTemperature = temChangeUnit(jsonDataObj.batteryTemperature)
            const end = jsonDataObj.timestamp
            let start = ''
            if (jsonDataObj.eventId == 2) {
              for (var i = 0; i < list.length; i++) {
                var m = JSON.parse(list[i].jsonData)
                if (m.timestamp < end && m.eventId == 1) {
                  start = m.timestamp
                  break
                }
              }
            }
            jsonDataObj.chargingTime = start ? usedTime(end - start) : '--'
            this.tableData.push(jsonDataObj)
          })
          console.log(this.tableData)
        }
      })
    },
    // 筛选改变事件
    changeSearch() {
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 分页----start
    handleSizeChange(val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) {
      // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end

  }
}
</script>
